<template>
  <div class="wrapper">
    <span class="w-title">{{ adding?'新建缴费信息':(editing ? "修改缴费信息" : "缴费详情信息") }}</span>
    <v-divider class="my-3"/>
    <v-container fluid grid-list-md class="xn-form pa-0">
      <div class="detail-btns">
        <v-btn color="info" flat @click="cancel">&lt; 返回缴费列表</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="!adding" color="error" flat outline @click="deleteThisItem">删除</v-btn>
        <v-btn v-if="detailing" color="info" flat class="btn-to-edit" @click="toEdit">去编辑 &gt;</v-btn>
      </div>
      <div class="form-panel">
        <div class="form-panel-head">基本信息</div>
        <div class="form-panel-body">
          <v-container fluid grid-list-md class="pa-0">
            <v-layout wrap>
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="editing||adding?'required':''">公司名称:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-autocomplete
                  ref="form.companyId"
                  v-model="item.companyId"
                  no-data-text="无可用数据"
                  :items="companies"
                  :label="detailing?'':'请选择公司'"
                  :rules="[rules.required]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-autocomplete>
              </v-flex>
              <!--              <v-flex xs3 md2 class="d-flex mt-2">-->
              <!--                <label :class="editing||adding?'required':''">合同名称:</label>-->
              <!--              </v-flex>-->
              <!--              <v-flex xs9 md4>-->
              <!--                <v-autocomplete-->
              <!--                  no-data-text="无可用数据"-->
              <!--                  ref="form.contractId"-->
              <!--                  :items="contracts"-->
              <!--                  v-model="item.contractId"-->
              <!--                  :label="detailing?'':'请选择合同'"-->
              <!--                  :rules="[rules.required]"-->
              <!--                  outline-->
              <!--                  solo-->
              <!--                  :disabled="detailing"-->
              <!--                ></v-autocomplete>-->
              <!--              </v-flex>-->
              <v-flex xs3 md2 class="d-flex mt-2">
                <label :class="editing||adding?'required':''">金额:</label>
              </v-flex>
              <v-flex xs9 md4>
                <v-text-field
                  ref="form.amount"
                  v-model="item.amount"
                  :label="detailing?'':'请输入金额'"
                  :rules="[rules.required,rules.isNumber]"
                  outline
                  solo
                  :disabled="detailing"
                ></v-text-field>
              </v-flex>
              <!--              <v-flex xs3 md2 class="d-flex mt-2"></v-flex>-->
              <!--              <v-flex xs9 md4></v-flex>-->
              <v-flex xs3 md2 class="d-flex mt-2">
                <label>备注:</label>
              </v-flex>
              <v-flex xs9 md10>
                <v-textarea
                  v-if="!detailing"
                  ref="form.notes"
                  v-model="item.notes"
                  outline
                  solo
                ></v-textarea>
                <p v-if="detailing" class="detail-area">{{ item.notes }}</p>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </div>
    </v-container>

    <v-container fluid grid-list-md class="pa-0 my-5">
      <v-layout>
        <v-flex xs3 md4></v-flex>
        <v-flex xs6 md4 style="display:flex;justify-content: space-around">
          <v-btn outline @click="cancel">返回</v-btn>
          <v-btn v-if="!detailing" color="info" @click="save">保存</v-btn>
        </v-flex>
        <v-flex xs3 md4></v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import axios from "../axios";
  import {mapState, mapActions} from "vuex";

  export default {
    name: "PaymentForm",
    components: {},
    computed: {
      ...mapState({
        showLoading: state => state.showLoading,
        companies: state => state.miniCompanies,
        companiesMap: state => state.miniCompaniesMap
      }),
      id() {
        return this.$route.params.paymentId;
      },
      adding() {
        return !this.$route.params.paymentId;
      },
      editing() {
        return (!!this.id) && this.$route.name === "payment-form-edit"
      },
      detailing() {
        return (!!this.id) && this.$route.name === "payment-form-detail"
      }
    },
    data: () => {
      return {
        rules: {
          required: value => !!value || "必填",
          length5: value => (!!value && value.length >= 5) || "长度至少为5",
          length8: value => (!!value && value.length >= 8) || "长度至少为8",
          phoneNumber: value => {
            const pattern = /^1\d{10}$/;
            return pattern.test(value) || "请输入正确的手机号";
          },
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            // eslint-disable-next-line
            return (typeof value === "undefined" || value === null || value === "" || pattern.test(value)) || "请输入正确的邮箱";
          },
          isNumber: value => {
            const pattern = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;  ///^\d+$/
            return (typeof value === "undefined" || value === null || value === "" || pattern.test(value)) || "请输入正确的金额";
          },
        },
        hasErrors: false,
        item: {},
        contracts: []
      };
    },
    methods: {
      ...mapActions(["setLoading"]),
      resetForm() {
        Object.keys(this.item).forEach(f => {
          if (
            this.$refs["form." + f] !== null &&
            typeof this.$refs["form." + f] !== "undefined"
          )
            this.$refs["form." + f].resetValidation();
        });
      },
      cancel() {
        this.$router.push({name: 'payments'});
      },
      toEdit() {
        this.$router.push("edit");
      },
      deleteThisItem() {
        this.$confirm("确定删除?").then(
          res => {
            if (res) {
              let arr = [];
              arr.push(this.$route.params.paymentId);
              this.setLoading(true);
              axios
                .post("/payments/delete", {
                  paymentIds: arr
                })
                .then(() => {
                  this.setLoading(false);

                  this.$confirm("删除成功", {buttonFalseText: null}).then(() => {
                      this.cancel();
                    }
                  );
                });
            }
          }
        );
      },
      save() {
        this.validate();
        if (!this.hasErrors) {
          if (this.editing) {
            this.setLoading(true);
            axios
              .put("/payments/" + this.item.paymentId, this.item)
              .then(() => {
                this.setLoading(false);

                this.$confirm("修改成功", {buttonFalseText: null}).then(() => {
                  this.cancel();
                });
              })
              .catch(reason => {
                this.$confirm(reason.response.data.message, {
                  buttonFalseText: null
                });
                this.setLoading(false);
              });
          } else {
            this.setLoading(true);
            axios
              .post("/payments", this.item)
              .then(() => {
                this.setLoading(false);

                this.$confirm("创建成功", {buttonFalseText: null}).then(() => {
                  this.cancel();
                });
              })
              .catch(reason => {
                this.$confirm(reason.response.data.message, {
                  buttonFalseText: null
                });
                this.setLoading(false);
              });
          }
        }
      },
      validate() {
        this.hasErrors = false;

        Object.keys(this.item).forEach(f => {
          if (
            this.$refs["form." + f] !== null &&
            typeof this.$refs["form." + f] !== "undefined"
          ) {
            if (!this.$refs["form." + f].validate(true)) {
              this.hasErrors = true;
            }
          }
        });
      }
    },
    created() {
      if (this.editing || this.detailing) {
        this.setLoading(true);
        axios.get("/payments/" + this.$route.params.paymentId).then(res => {
          this.item = res.data;
          //this.companyChanged(false);
          this.setLoading(false);
        })
          .catch(reason => {
            this.$confirm(reason.response.data.message, {
              buttonFalseText: null
            });
            this.setLoading(false);
          });
      } else {
        this.item = {
          //contractId: null,
          companyId: null,
          amount: null,
          notes: null
        };
      }
    }
  };
</script>

<style scoped></style>
